

import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { CopyTextToClipboard } from "../../helpers/copy";
import Apiauth from "@api/Apiauth";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import {
  SafetyCertificateOutlined,
  CopyOutlined,
  SoundOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { Tabs, Card, Button, Input, Spin, Switch, Empty } from "antd";
import AppContext from "../../components/AppContext";
import config from "../../config/app.config";
import SetNotify from "./setNotify";
import { withTranslation } from "react-i18next";
import Apisetting from "../../api/Apisetting";
import { confirmSwal, hasPermission, openNotification, showToast } from "../../utils";
import moment from "moment";

class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      dataall_keyapi: [],
      isLoadingApiKeys: false,
      isGeneratingToken: false,
      loading: false,
    };
    this.inputRef = React.createRef();
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    await this.fetchApiKeys();
  }

  fetchApiKeys = async () => {
    this.setState({ isLoadingApiKeys: true });

    try {
      const res = await Apiauth.getdata_keyapiserver();
      if (res.data.success && res.data.data) {
        const keyData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        this.setState({ dataall_keyapi: keyData });
      } else {
        this.setState({ dataall_keyapi: [] });
      }
    } catch (err) {
      console.error("Error fetching API keys:", err);
      this.setState({ dataall_keyapi: [] });
    } finally {
      this.setState({ isLoadingApiKeys: false });
    }
  };

  handleGenerateToken = async () => {
    const { t } = this.props;
    const confirmGenerate = await confirmSwal("question", t("Are you sure you want to generate a new API key?"));
    if (!confirmGenerate) return;

    this.setState({ isGeneratingToken: true });
    try {
      const res = await Apiauth.generateNewApiKey();
      if (res.data?.success) {
        openNotification("success", t("API Key Generated"), res.data.message);
        this.fetchApiKeys();
      } else {
        openNotification("error", t("Generation Failed"), res.data.message);
      }
    } catch (err) {
      openNotification("error", "API Error", err.response?.data?.message || err.message);
    } finally {
      this.setState({ isGeneratingToken: false });
    }
  };

  onChangeEnabled = async (value) => {
    const { t } = this.props;
    const { getAllDataMerchang } = this.context;
    this.setState({ loading: true });
    const confirmChangeEnabled = await confirmSwal("question", t("Are you sure you want to {{action}} the customer verification service?", { action: value ? t("enable") : t("disable") }));
    if (!confirmChangeEnabled) {
      this.setState({ loading: false });
      return;
    }

    Apisetting.enabled_verify_hub({ enabled_verify_hub: value })
      .then((res) => {
        if (res.status === 200) {
          showToast("success", t("{{action}} customer verification service", { action: value ? t("enable") : t("disable") }));
          if (typeof getAllDataMerchang === "function") getAllDataMerchang();
        }
      })
      .catch((error) => {
        openNotification("error", `Error`, error.response?.data?.message || error.message);
      })
      .finally(() => this.setState({ loading: false }));
  };
  handleFocus = (options) => {
    // ใน Class Component การเข้าถึง ref จะผ่าน .current
    if (options?.cursor === 'all' && this.inputRef.current) {
      this.inputRef.current?.focus(options);
    }
    if (options?.copyTxt) {
      CopyTextToClipboard(options?.copyTxt)
    }
  };

  render() {
    const { t, i18n } = this.props;
    const currentLanguage = i18n.language;
    const {
      getAllDataMerchang,
      resDataSetingNotify,
      fetchDataSetingNotify,
      resDataNotify,
      isMerchantData,
      resProfileAdmin
    } = this.context;

    const { dataall_keyapi, isLoadingApiKeys, isGeneratingToken, loading } = this.state;
    const { enabled_verify_hub, id, name } = isMerchantData || {};

    const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];

    // Permissions
    const canVerifyCustomer = hasPermission(userPermissions, "on_off_verifyCustomer_setting");
    const canCreateApiKey = hasPermission(userPermissions, "CREATE_API_KEY_setting");

    // ตรวจสอบสิทธิ์การเข้าถึง Tab การตั้งค่าการแจ้งเตือน on_off_room_notify_setting
    const canSetNotify = hasPermission(userPermissions, "set_notify_tab_setting");
    const canaddNotify = hasPermission(userPermissions, "add_room_notify_setting");
    const canEditNotify = hasPermission(userPermissions, "edit_room_notify_setting");
    const canDelSetNotify = hasPermission(userPermissions, "del_room_notify_setting");
    const canOn_offNotify = hasPermission(userPermissions, "on_off_room_notify_setting");

    // กำหนดรายการ Tabs โดยเช็คสิทธิ์ก่อน
    const tabItems = [
      {
        key: "1",
        label: t("General settings"),
        icon: <SafetyCertificateOutlined />,
        children: (
          <div className="row clearfix mb-5">
            <div className="col-md-6 col-sm-12">
              <Card className="mt-1" title={<b>{t("BASE URL")}</b>}>
                <div className="p-3">

                  <Input
                    className="d-block mt-3"
                    defaultValue={`${config.apiURL}`}
                    ref={this.inputRef}
                    readOnly
                    style={{
                      textTransform: "lowercase",
                    }}
                    onClick={() =>
                      this.handleFocus({ cursor: 'all', copyTxt: config.apiURL })
                    }
                  />
                </div>
              </Card>

              <Card className="mt-3" title={<b>{t("บริการตรวจสอบบัญชีลูกค้า")}</b>}>
                <div className="p-3">
                  <Switch
                    loading={loading}
                    unCheckedChildren={t("disabled")}
                    checkedChildren={t("enabled")}
                    size="small"
                    checked={Boolean(enabled_verify_hub)}
                    onChange={(checked) => canVerifyCustomer ? this.onChangeEnabled(checked) : alert(t("You don't have permission to enable/disable this setting."))}
                    style={{ background: enabled_verify_hub ? "#52c41a" : "#ff4d4f" }}
                  />
                  <span className="d-block mt-2 fs-12">{t("enabled_verify_hub", { name: config.web_name })}</span>
                </div>
              </Card>

              <Card
                className="mt-3"
                title={<b>{t("API KEY")}</b>}
                extra={
                  <Button
                    size="small"
                    type="primary"
                    className={`${!canCreateApiKey ? "d-none" : ""}`}
                    onClick={() => canCreateApiKey ? this.handleGenerateToken() : alert(t("You don't have permission to generate API key."))}
                    loading={isGeneratingToken}
                  >
                    {t("CREATE API KEY")}
                  </Button>
                }
              >
                {isLoadingApiKeys ? (
                  <div className="text-center p-5"><Spin /></div>
                ) : dataall_keyapi.length > 0 ? (
                  <div className="p-3 bg-light rounded">
                    {(() => {
                      const latestKey = [...dataall_keyapi].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0];
                      return (
                        <>
                          <div className="mb-2">
                            <b>Access Key:</b> <code className="mx-2  text-info">{latestKey.accessKey || latestKey.api_key}</code>
                            <CopyOutlined className="hover" onClick={() => CopyTextToClipboard(latestKey.accessKey || latestKey.api_key)} />
                          </div>
                          <div className="mb-3">
                            <b>Secret Key:</b> <code className="mx-2 text-info">{latestKey.secretKey || latestKey.api_secret}</code>
                            <CopyOutlined className="hover" onClick={() => CopyTextToClipboard(latestKey.secretKey || latestKey.api_secret)} />
                          </div>
                          <div className="text-muted border-top pt-2 " style={{ fontSize: '12px' }}>
                            <CalendarOutlined className="me-1" /> {t("createdAt")}: {moment(latestKey.updated_at).locale(currentLanguage).format("LLL")}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                ) : <Empty description={t("API Key not found.")} />}
              </Card>
            </div>
          </div>
        )
      },
      // Tab 2: Notification (แสดงเฉพาะเมื่อมีสิทธิ์)
      ...(canSetNotify ? [{
        key: "2",
        label: t("Set Notification"),
        icon: <SoundOutlined />,
        children: (
          <div className="col-md-12">
            <SetNotify
              getAllDataMerchang={getAllDataMerchang}
              resDataSetingNotify={resDataSetingNotify}
              fetchDataSetingNotify={fetchDataSetingNotify}
              merchantId={id}
              nameMerchang={name}
              resDataNotify={resDataNotify}
              t={t}
              canaddNotify={canaddNotify}
              canEditNotify={canEditNotify}
              canDelSetNotify={canDelSetNotify}
              canOn_offNotify={canOn_offNotify}
            />
          </div>
        )
      }] : [])
    ];

    return (
      <div className="container-fluid">
        <PageHeader
          HeaderText={t("Setting")}
          Breadcrumb={[
            { name: removeSlashesFromPath(window.location.pathname), navigate: window.location.pathname }
          ]}
        />
        <br className="sm-hiden" />
        <Tabs defaultActiveKey="1" items={tabItems} />
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(Index));